import { DISPENSE_ATTEMPTS_TAB } from 'models/dispense-attempts/constants';

export default (dispenseAttempt) => {
  if (!dispenseAttempt) return;

  if (dispenseAttempt.review) return DISPENSE_ATTEMPTS_TAB.REVIEWED;
  else return DISPENSE_ATTEMPTS_TAB.PENDING;
};
